/**
 * @generated SignedSource<<1c8780891faa12f99f278e375d1ab9a8>>
 * @relayHash 6ba0035c364b006b4f5ae5667cd95b3f
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/545.0.0-2026-02-04T17:00:32.354Z/designSeriesRootQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type designSeriesRootQuery$variables = {
  designSeriesName?: string | null;
  primaryCreatorDesignsMaxCount?: number | null;
};
export type designSeriesRootQuery$data = {
  readonly viewer: {
    readonly iconicDesignSeriesPage: {
      readonly cmsTopModule: {
        readonly mainImage: string | null;
        readonly title: string | null;
      } | null;
      readonly primaryCreator: {
        readonly displayName: string | null;
      } | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"DesignSeriesLayout_viewer">;
  };
};
export type designSeriesRootQuery = {
  response: designSeriesRootQuery$data;
  variables: designSeriesRootQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": "",
    "kind": "LocalArgument",
    "name": "designSeriesName"
  },
  {
    "defaultValue": 6,
    "kind": "LocalArgument",
    "name": "primaryCreatorDesignsMaxCount"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "designSeriesName",
    "variableName": "designSeriesName"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mainImage",
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "maxDesignsCount",
    "variableName": "primaryCreatorDesignsMaxCount"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLinkable",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "IconicDesignSeriesItem",
  "kind": "LinkedField",
  "name": "designs",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "linkData",
      "plural": false,
      "selections": [
        (v8/*: any*/),
        (v7/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageUrl",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "designSeriesRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "IconicDesignSeriesPage",
            "kind": "LinkedField",
            "name": "iconicDesignSeriesPage",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IconicDesignSeriesCmsTopModule",
                "kind": "LinkedField",
                "name": "cmsTopModule",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "PrimaryCreatorForSeries",
                "kind": "LinkedField",
                "name": "primaryCreator",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DesignSeriesLayout_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "designSeriesRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "IconicDesignSeriesPage",
            "kind": "LinkedField",
            "name": "iconicDesignSeriesPage",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IconicDesignSeriesCmsTopModule",
                "kind": "LinkedField",
                "name": "cmsTopModule",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "bannerImage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "PrimaryCreatorForSeries",
                "kind": "LinkedField",
                "name": "primaryCreator",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IconicDesignSeriesCmsTopModule",
                    "kind": "LinkedField",
                    "name": "cmsTopModule",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LinkData",
                    "kind": "LinkedField",
                    "name": "linkData",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              (v10/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CreatorLinks",
                "kind": "LinkedField",
                "name": "creatorLinks",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LinkData",
                    "kind": "LinkedField",
                    "name": "linkData",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 8
                  }
                ],
                "concreteType": "WordpressArticlesType",
                "kind": "LinkedField",
                "name": "editorialArticles",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalResults",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WordpressArticleType",
                    "kind": "LinkedField",
                    "name": "articles",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WordpressArticleImageType",
                        "kind": "LinkedField",
                        "name": "imageUrl",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "full",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "subtitle",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "link",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "source",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "editorialArticles(first:8)"
              }
            ],
            "storageKey": null
          },
          {
            "alias": "isWordpressArticlesEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "WP_EDITORIAL"
              }
            ],
            "kind": "ScalarField",
            "name": "isEnabledByLocale",
            "storageKey": "isEnabledByLocale(featureName:\"WP_EDITORIAL\")"
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/545.0.0-2026-02-04T17:00:32.354Z/designSeriesRootQuery",
    "metadata": {},
    "name": "designSeriesRootQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d61c18bb31d2fc05e769f46a5c6c9d78";

export default node;
